import script from "./HodlBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./HodlBanner.vue?vue&type=script&setup=true&lang=ts"

import "./HodlBanner.vue?vue&type=style&index=0&id=27016715&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27016715"]])

export default __exports__